import { createMasterDataCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type SeverityDto = EntityRecord;
export type SeverityCreateRequest = EntityCreateRequest;
export type SeverityUpdateRequest = EntityUpdateRequest;

export const severityApi: CrudApi<SeverityDto, SeverityCreateRequest, SeverityUpdateRequest> = createMasterDataCrudApi({ masterType: "severity" });
